export const HomeIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 10.1503V17.9668C21 20.1943 19.2091 22 17 22H7C4.79086 22 3 20.1943 3 17.9668V10.1503C3 8.93937 3.53964 7.7925 4.46986 7.02652L9.46986 2.90935C10.9423 1.69689 13.0577 1.69688 14.5301 2.90935L19.5301 7.02652C20.4604 7.7925 21 8.93937 21 10.1503ZM15.25 17.25V19.5C15.25 20.0523 14.8023 20.5 14.25 20.5H9.75C9.19772 20.5 8.75 20.0523 8.75 19.5V17.25C8.75 15.4551 10.2051 14 12 14C13.7949 14 15.25 15.4551 15.25 17.25Z"
      fill="#7D899C"
    />
  </svg>
);

export const CreateIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 6V18C3 20.2091 4.79086 22 7 22H11.3431C11.6509 22 11.955 21.9645 12.25 21.8959V18C12.25 15.3766 14.3766 13.25 17 13.25H20.8959C20.9645 12.955 21 12.6509 21 12.3431V6C21 3.79086 19.2091 2 17 2H7C4.79086 2 3 3.79086 3 6ZM14.1716 20.8284C14.039 20.961 13.898 21.0833 13.75 21.1949V18C13.75 16.2051 15.2051 14.75 17 14.75H20.1949C20.0833 14.898 19.961 15.039 19.8284 15.1716L14.1716 20.8284ZM12 5.25C12.4142 5.25 12.75 5.58579 12.75 6V8.25H15C15.4142 8.25 15.75 8.58579 15.75 9C15.75 9.41421 15.4142 9.75 15 9.75H12.75V12C12.75 12.4142 12.4142 12.75 12 12.75C11.5858 12.75 11.25 12.4142 11.25 12V9.75H9C8.58579 9.75 8.25 9.41421 8.25 9C8.25 8.58579 8.58579 8.25 9 8.25H11.25V6C11.25 5.58579 11.5858 5.25 12 5.25Z"
      fill="#7D899C"
    />
  </svg>
);

export const AdCopyIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 2C3.79086 2 2 3.79086 2 6V18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18V6C22 3.79086 20.2091 2 18 2H6ZM12 5.25C12.3028 5.25 12.5759 5.43205 12.6923 5.71154L17.6923 17.7115C17.8516 18.0939 17.6708 18.533 17.2885 18.6923C16.9061 18.8516 16.467 18.6708 16.3077 18.2885L14.8333 14.75H9.16668L7.69232 18.2885C7.53301 18.6708 7.0939 18.8516 6.71155 18.6923C6.3292 18.533 6.14839 18.0939 6.3077 17.7115L11.3077 5.71154C11.4242 5.43205 11.6972 5.25 12 5.25ZM12 7.95L14.2083 13.25H9.79168L12 7.95Z"
      fill="#7D899C"
    />
  </svg>
);

export const AddIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 6V18M18 12L6 12"
      stroke="#7D899C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ImageAdIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.25 6C1.25 3.37665 3.37665 1.25 6 1.25H18C20.6234 1.25 22.75 3.37665 22.75 6V18C22.75 20.6234 20.6234 22.75 18 22.75H6C3.37665 22.75 1.25 20.6234 1.25 18V6ZM6 2.75C4.20507 2.75 2.75 4.20507 2.75 6V14.5L5.27153 16.181C6.85802 17.2387 8.9705 17.0295 10.3188 15.6812L13.6812 12.3188C15.0295 10.9705 17.142 10.7613 18.7285 11.819L21.1094 13.4063C21.158 13.4387 21.2049 13.473 21.25 13.5091V6C21.25 4.20507 19.7949 2.75 18 2.75H6ZM8.5 11C9.88071 11 11 9.88071 11 8.5C11 7.11929 9.88071 6 8.5 6C7.11929 6 6 7.11929 6 8.5C6 9.88071 7.11929 11 8.5 11Z"
      fill="#7D899C"
    />
  </svg>
);

export const VideoAdIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 7.25H15.4573L19.0982 2.15265C20.7734 2.62992 22 4.17171 22 6V7.25ZM2 8.75H22V18C22 20.2091 20.2091 22 18 22H6C3.79086 22 2 20.2091 2 18V8.75ZM5.61397 7.25H2V6C2 3.79086 3.79086 2 6 2H9.36397L5.61397 7.25ZM7.45733 7.25L11.2073 2H17.3639L13.6139 7.25H7.45733ZM12 12.889L12.2678 12.5995C13.0072 11.8002 14.206 11.8002 14.9454 12.5995C15.6849 13.3988 15.6849 14.6948 14.9454 15.4941L13.0711 17.5204C12.4795 18.1599 11.5205 18.1599 10.9289 17.5204L9.05456 15.4941C8.31515 14.6948 8.31515 13.3988 9.05456 12.5995C9.79398 11.8002 10.9928 11.8002 11.7322 12.5995L12 12.889Z"
      fill="#7D899C"
    />
  </svg>
);

export const DeleteIcon = (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.4167 8.25065L16.7604 16.7819C16.6135 18.6922 15.0205 20.1673 13.1046 20.1673H8.89545C6.97948 20.1673 5.38653 18.6922 5.23958 16.7819L4.58333 8.25065M19.25 6.41732C16.8686 5.2568 14.0375 4.58398 11 4.58398C7.96249 4.58398 5.13142 5.2568 2.75 6.41732M9.16667 4.58398V3.66732C9.16667 2.6548 9.98748 1.83398 11 1.83398C12.0125 1.83398 12.8333 2.6548 12.8333 3.66732V4.58398M9.16667 10.084V15.584M12.8333 10.084V15.584"
      stroke="#7D899C"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const LinkIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1362 5.86417C16.5882 4.31611 14.0783 4.31611 12.5302 5.86418L10.8635 7.53085C10.5706 7.82374 10.0957 7.82374 9.80285 7.53085C9.50996 7.23796 9.50996 6.76308 9.80285 6.47019L11.4695 4.80352C13.6034 2.66966 17.063 2.66966 19.1969 4.80351C21.3308 6.93737 21.3308 10.397 19.1969 12.5309L17.5302 14.1976C17.2373 14.4905 16.7625 14.4905 16.4696 14.1976C16.1767 13.9047 16.1767 13.4298 16.4696 13.1369L18.1362 11.4702C19.6843 9.92215 19.6843 7.41224 18.1362 5.86417ZM14.6516 9.34882C14.9445 9.64172 14.9445 10.1166 14.6516 10.4095L10.409 14.6521C10.1161 14.945 9.64122 14.945 9.34833 14.6521C9.05544 14.3592 9.05544 13.8844 9.34833 13.5915L13.591 9.34882C13.8839 9.05593 14.3587 9.05593 14.6516 9.34882ZM11.4695 18.1368C9.92142 19.6849 7.41151 19.6849 5.86344 18.1368C4.31538 16.5888 4.31538 14.0788 5.86344 12.5308L7.53012 10.8641C7.82301 10.5712 7.82301 10.0963 7.53012 9.80344C7.23723 9.51055 6.76235 9.51055 6.46946 9.80344L4.80278 11.4701C2.66893 13.604 2.66893 17.0636 4.80278 19.1975C6.93664 21.3313 10.3963 21.3313 12.5302 19.1975L14.1968 17.5308C14.4897 17.2379 14.4897 16.763 14.1968 16.4701C13.9039 16.1773 13.4291 16.1773 13.1362 16.4701L11.4695 18.1368Z"
      fill="#7D899C"
    />
  </svg>
);

export const FolderIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 17V10C22 7.79086 20.2091 6 18 6H15.3333C14.4679 6 13.6257 5.71929 12.9333 5.2L11.0667 3.8C10.3743 3.28071 9.53215 3 8.66667 3H6C3.79086 3 2 4.79086 2 7V17C2 19.2091 3.79086 21 6 21H18C20.2091 21 22 19.2091 22 17Z"
      fill="#7D899C"
    />
  </svg>
);

export const OpenInNewIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 8.99999L21 3M21 3L15 3M21 3L10 14"
      stroke="#7D899C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 5H7C4.79086 5 3 6.79086 3 9V17C3 19.2091 4.79086 21 7 21H15C17.2091 21 19 19.2091 19 17V12"
      stroke="#7D899C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BrandkitIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      d="M16.5 13.5V5.74264C16.5 4.94699 16.1839 4.18393 15.6213 3.62132L14.3787 2.37868C13.8161 1.81607 13.053 1.5 12.2574 1.5H5.74264C4.94699 1.5 4.18393 1.81607 3.62132 2.37868L2.37868 3.62132C1.81607 4.18393 1.5 4.94699 1.5 5.74264V13.5C1.5 15.1569 2.84315 16.5 4.5 16.5H13.5C15.1569 16.5 16.5 15.1569 16.5 13.5Z"
      fill="#7D899C"
    />
    <path
      d="M12.2572 1.5H5.74246C4.94681 1.5 4.18375 1.81607 3.62114 2.37868L2.37849 3.62132C1.93337 4.06645 1.64257 4.63705 1.54053 5.25H16.4591C16.3571 4.63705 16.0663 4.06645 15.6211 3.62132L14.3785 2.37868C13.8159 1.81607 13.0528 1.5 12.2572 1.5Z"
      fill="#7D899C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6204 8.57668C11.8542 8.78125 11.8779 9.13662 11.6733 9.37042L9.52092 11.8303C9.0584 12.3589 8.26171 12.4297 7.71325 11.9909L6.39863 10.9392C6.15604 10.7452 6.11671 10.3912 6.31078 10.1486C6.50485 9.90603 6.85883 9.8667 7.10141 10.0608L8.41603 11.1125C8.49438 11.1751 8.60819 11.165 8.67427 11.0895L10.8267 8.6296C11.0313 8.3958 11.3866 8.37211 11.6204 8.57668Z"
      fill="#7D899C"
    />
  </svg>
);

export const AssetsIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Huge-icon/interface/bulk/layers">
      <g id="layers">
        <path
          id="Vector 2462"
          opacity="0.4"
          d="M11.1723 21.6242L3.0027 17.9107C2.2211 17.5554 2.22111 16.4453 3.0027 16.09L11.1723 12.3765C11.6981 12.1375 12.3017 12.1375 12.8275 12.3765L20.9971 16.09C21.7787 16.4453 21.7787 17.5554 20.9971 17.9107L12.8275 21.6242C12.3017 21.8632 11.6981 21.8632 11.1723 21.6242Z"
          fill="#7D899C"
        />
        <path
          id="Vector 2461"
          d="M11.1723 16.6242L3.0027 12.9107C2.2211 12.5554 2.22111 11.4453 3.0027 11.09L11.1723 7.37653C11.6981 7.13751 12.3017 7.13751 12.8275 7.37653L20.9971 11.09C21.7787 11.4453 21.7787 12.5554 20.9971 12.9107L12.8275 16.6242C12.3017 16.8632 11.6981 16.8632 11.1723 16.6242Z"
          fill="#7D899C"
        />
        <path
          id="Vector 2457"
          opacity="0.4"
          d="M11.1723 11.6242L3.0027 7.91071C2.2211 7.55544 2.22111 6.44525 3.0027 6.08998L11.1723 2.37653C11.6981 2.13751 12.3017 2.13751 12.8275 2.37653L20.9971 6.08998C21.7787 6.44525 21.7787 7.55544 20.9971 7.91072L12.8275 11.6242C12.3017 11.8632 11.6981 11.8632 11.1723 11.6242Z"
          fill="#7D899C"
        />
      </g>
    </g>
  </svg>
);

export const DownloadIcon = (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.0625 15.5833C2.0625 17.9881 4.01193 19.9375 6.41667 19.9375L15.5833 19.9375C17.9881 19.9375 19.9375 17.9881 19.9375 15.5833L19.9375 11.9167C19.9375 9.51193 17.9881 7.5625 15.5833 7.5625L15.125 7.5625C14.7453 7.5625 14.4375 7.8703 14.4375 8.25C14.4375 8.62969 14.7453 8.9375 15.125 8.9375L15.5833 8.9375C17.2287 8.9375 18.5625 10.2713 18.5625 11.9167L18.5625 15.5833C18.5625 17.2287 17.2287 18.5625 15.5833 18.5625L6.41667 18.5625C4.77132 18.5625 3.4375 17.2287 3.4375 15.5833L3.4375 11.9167C3.4375 10.2713 4.77132 8.9375 6.41667 8.9375L6.875 8.9375C7.2547 8.9375 7.5625 8.62969 7.5625 8.25C7.5625 7.8703 7.2547 7.5625 6.875 7.5625L6.41667 7.5625C4.01193 7.5625 2.0625 9.51193 2.0625 11.9167L2.0625 15.5833ZM7.76386 11.4861C7.49538 11.2177 7.49538 10.7823 7.76386 10.5139C8.03235 10.2454 8.46765 10.2454 8.73614 10.5139L10.3125 12.0902L10.3125 2.75C10.3125 2.3703 10.6203 2.0625 11 2.0625C11.3797 2.0625 11.6875 2.3703 11.6875 2.75L11.6875 12.0902L13.2639 10.5139C13.5324 10.2454 13.9677 10.2454 14.2361 10.5139C14.5046 10.7823 14.5046 11.2177 14.2361 11.4861L11.4861 14.2361C11.2177 14.5046 10.7824 14.5046 10.5139 14.2361L7.76386 11.4861Z"
      fill="#7D899C"
    />
  </svg>
);

export const TransformLocation = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_1836_40471)">
      <path
        d="M14.6667 7.33398L14.6667 8.66732"
        stroke="#AEB6C4"
        strokeLinecap="round"
      />
      <path
        d="M1.33325 7.33398L1.33325 8.66732"
        stroke="#AEB6C4"
        strokeLinecap="round"
      />
      <path
        d="M7.99992 1.33398V14.6673M14.6666 8.00065L1.33325 8.00065M7.33325 14.6673H8.66658M7.33325 1.33398H8.66658M7.33325 5.00065H8.66658M7.33325 11.0007H8.66658M10.9999 7.33398V8.66732M4.99992 7.33398V8.66732M3.99992 1.33398L4.66659 2.00065M4.66659 2.00065L5.33325 1.33398M4.66659 2.00065V2.66732M13.3333 10.6673L13.9999 11.334M13.9999 11.334L14.6666 10.6673M13.9999 11.334L13.3333 12.0007M13.9999 11.334L14.6666 12.0007"
        stroke="#AEB6C4"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1836_40471">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const TransformRotation = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_1836_40486)">
      <path d="M8 14V14.6667" stroke="#AEB6C4" strokeLinecap="round" />
      <path
        d="M12.7141 3.28516L12.2427 3.75656"
        stroke="#AEB6C4"
        strokeLinecap="round"
      />
      <path
        d="M3.75732 12.2422L3.28592 12.7136"
        stroke="#AEB6C4"
        strokeLinecap="round"
      />
      <path d="M14.6667 8L14.0001 8" stroke="#AEB6C4" strokeLinecap="round" />
      <path
        d="M12.7141 12.7148L12.2427 12.2434"
        stroke="#AEB6C4"
        strokeLinecap="round"
      />
      <path
        d="M1.33325 8.00065C1.33325 11.6825 4.31802 14.6673 7.99992 14.6673C11.6818 14.6673 14.6666 11.6825 14.6666 8.00065C14.6666 4.31875 11.6818 1.33398 7.99992 1.33398M1.33325 8.00065C1.33325 4.31875 4.31802 1.33398 7.99992 1.33398M1.33325 8.00065H1.99992M7.99992 1.33398V2.00065M3.75724 3.75802L3.28584 3.28661M7.99992 12.0007C6.25829 12.0007 4.77664 10.8876 4.22753 9.33398H11.7723C11.2232 10.8876 9.74154 12.0007 7.99992 12.0007ZM7.99992 4.00065C9.74154 4.00065 11.2232 5.11373 11.7723 6.66732L4.22753 6.66732C4.77664 5.11373 6.25829 4.00065 7.99992 4.00065Z"
        stroke="#AEB6C4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1836_40486">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const TransformScale = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_1836_40501)">
      <path
        d="M12.1574 5.92193L13.1967 6.96129M10.0786 8.00065L11.118 9.04M7.99995 10.0794L9.03931 11.1187M5.92127 12.1581L6.96063 13.1974M5.9212 14.2368L14.2361 5.92193C14.8101 5.34791 14.8101 4.41724 14.2361 3.84322L12.1574 1.7645C11.5833 1.19048 10.6527 1.19048 10.0786 1.7645L1.76377 10.0794C1.18975 10.6534 1.18975 11.5841 1.76377 12.1581L3.84249 14.2368C4.41651 14.8108 5.34718 14.8108 5.9212 14.2368Z"
        stroke="#AEB6C4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1836_40501">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const template = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      d="M22 18V7.65685C22 6.59599 21.5786 5.57857 20.8284 4.82843L19.1716 3.17157C18.4214 2.42143 17.404 2 16.3431 2H7.65685C6.59599 2 5.57857 2.42143 4.82843 3.17157L3.17157 4.82843C2.42143 5.57857 2 6.59599 2 7.65685V18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18Z"
      fill="#7D899C"
    />
    <path
      d="M16.3431 2H7.65677C6.5959 2 5.57849 2.42143 4.82834 3.17157L3.17149 4.82843C2.57799 5.42193 2.19025 6.18274 2.0542 7H21.9456C21.8096 6.18274 21.4218 5.42193 20.8283 4.82843L19.1715 3.17157C18.4213 2.42143 17.4039 2 16.3431 2Z"
      fill="#7D899C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 11.75C10.7574 11.75 9.75 12.7574 9.75 14C9.75 15.2426 10.7574 16.25 12 16.25C13.2426 16.25 14.25 15.2426 14.25 14C14.25 12.7574 13.2426 11.75 12 11.75ZM8.25 14C8.25 11.9289 9.92893 10.25 12 10.25C14.0711 10.25 15.75 11.9289 15.75 14C15.75 14.7643 15.5213 15.4752 15.1287 16.068L16.0303 16.9697C16.3232 17.2626 16.3232 17.7374 16.0303 18.0303C15.7374 18.3232 15.2626 18.3232 14.9697 18.0303L14.068 17.1287C13.4752 17.5213 12.7643 17.75 12 17.75C9.92893 17.75 8.25 16.0711 8.25 14Z"
      fill="#7D899C"
    />
  </svg>
);

export const environment = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      opacity="0.4"
      cx="16.0001"
      cy="15.9993"
      r="13.3333"
      fill="#7D899C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7425 10.7614C12.9583 9.5221 13.2472 8.40817 13.5906 7.46388C13.9816 6.38863 14.427 5.57837 14.8789 5.05282C15.3331 4.52451 15.7149 4.36814 16.0003 4.36814C16.2856 4.36814 16.6675 4.52451 17.1217 5.05282C17.5736 5.57837 18.019 6.38863 18.41 7.46388C18.7534 8.40817 19.0423 9.5221 19.2581 10.7614C18.2142 10.6618 17.1223 10.6093 16.0003 10.6093C14.8783 10.6093 13.7864 10.6618 12.7425 10.7614ZM10.9816 10.9806C11.2187 9.45014 11.5621 8.0614 11.9909 6.88219C12.4213 5.6986 12.9539 4.68089 13.5882 3.94317C14.22 3.20821 15.0322 2.66602 16.0003 2.66602C16.9684 2.66602 17.7805 3.20821 18.4124 3.94317C19.0467 4.68089 19.5793 5.6986 20.0097 6.88219C20.4385 8.0614 20.7819 9.45014 21.019 10.9806C22.5495 11.2177 23.9382 11.5611 25.1174 11.9899C26.301 12.4203 27.3187 12.9529 28.0564 13.5872C28.7914 14.2191 29.3336 15.0312 29.3336 15.9993C29.3336 16.9674 28.7914 17.7796 28.0564 18.4114C27.3187 19.0457 26.301 19.5783 25.1174 20.0087C23.9382 20.4375 22.5495 20.7809 21.019 21.018C20.7819 22.5485 20.4385 23.9372 20.0097 25.1164C19.5793 26.3 19.0467 27.3177 18.4124 28.0555C17.7805 28.7904 16.9684 29.3326 16.0003 29.3326C15.0322 29.3326 14.22 28.7904 13.5882 28.0555C12.9539 27.3177 12.4213 26.3 11.9909 25.1164C11.5621 23.9372 11.2187 22.5485 10.9816 21.018C9.45111 20.7809 8.06238 20.4375 6.88317 20.0087C5.69958 19.5783 4.68186 19.0457 3.94414 18.4114C3.20918 17.7796 2.66699 16.9674 2.66699 15.9993C2.66699 15.0312 3.20918 14.2191 3.94414 13.5872C4.68186 12.9529 5.69958 12.4203 6.88317 11.9899C8.06238 11.5611 9.45111 11.2177 10.9816 10.9806ZM10.7624 19.2571C9.52308 19.0413 8.40915 18.7524 7.46486 18.409C6.38961 18.018 5.57934 17.5726 5.0538 17.1207C4.52549 16.6665 4.36911 16.2847 4.36911 15.9993C4.36911 15.714 4.52549 15.3321 5.0538 14.8779C5.57934 14.426 6.38961 13.9806 7.46486 13.5896C8.40915 13.2462 9.52308 12.9573 10.7624 12.7415C10.6628 13.7854 10.6102 14.8773 10.6102 15.9993C10.6102 17.1213 10.6628 18.2132 10.7624 19.2571ZM12.4983 19.5013C12.3778 18.3972 12.3124 17.2216 12.3124 15.9993C12.3124 14.777 12.3778 13.6015 12.4983 12.4974C13.6024 12.3768 14.778 12.3114 16.0003 12.3114C17.2226 12.3114 18.3981 12.3768 19.5022 12.4974C19.6228 13.6015 19.6882 14.777 19.6882 15.9993C19.6882 17.2216 19.6228 18.3972 19.5022 19.5013C18.3981 19.6218 17.2226 19.6872 16.0003 19.6872C14.778 19.6872 13.6024 19.6218 12.4983 19.5013ZM12.7425 21.2372C12.9583 22.4765 13.2472 23.5904 13.5906 24.5347C13.9816 25.61 14.427 26.4203 14.8789 26.9458C15.3331 27.4741 15.7149 27.6305 16.0003 27.6305C16.2856 27.6305 16.6675 27.4741 17.1217 26.9458C17.5736 26.4203 18.019 25.61 18.41 24.5347C18.7534 23.5904 19.0423 22.4765 19.2581 21.2372C18.2142 21.3368 17.1223 21.3894 16.0003 21.3894C14.8783 21.3894 13.7864 21.3368 12.7425 21.2372ZM21.2382 19.2571C22.4775 19.0413 23.5914 18.7524 24.5357 18.409C25.611 18.018 26.4212 17.5726 26.9468 17.1207C27.4751 16.6665 27.6315 16.2847 27.6315 15.9993C27.6315 15.714 27.4751 15.3321 26.9468 14.8779C26.4212 14.426 25.611 13.9806 24.5357 13.5896C23.5914 13.2462 22.4775 12.9573 21.2382 12.7415C21.3378 13.7854 21.3903 14.8773 21.3903 15.9993C21.3903 17.1213 21.3378 18.2132 21.2382 19.2571Z"
      fill="#7D899C"
    />
  </svg>
);

export const modal = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1836_40755)">
      <g clipPath="url(#clip1_1836_40755)">
        <path
          opacity="0.4"
          d="M28 10.6673C28 11.4037 27.403 12.0007 26.6667 12.0007H24C21.7909 12.0007 20 13.7915 20 16.0007V28.0006C20 28.737 19.403 29.334 18.6667 29.334C17.9303 29.334 17.3333 28.737 17.3333 28.0007V22.6673C17.3333 21.9309 16.7364 21.334 16 21.334C15.2636 21.334 14.6667 21.9309 14.6667 22.6673V28.0006C14.6667 28.737 14.0697 29.334 13.3333 29.334C12.597 29.334 12 28.737 12 28.0006V16.0007C12 13.7915 10.2091 12.0007 8 12.0007H5.33333C4.59695 12.0007 4 11.4037 4 10.6673C4 9.93094 4.59695 9.33398 5.33333 9.33398H26.6667C27.403 9.33398 28 9.93094 28 10.6673Z"
          fill="#7D899C"
        />
      </g>
    </g>
    <path
      d="M18.6666 5.33268C18.6666 3.86602 17.4666 2.66602 15.9999 2.66602C14.5333 2.66602 13.3333 3.86602 13.3333 5.33268C13.3333 6.79935 14.5333 7.99935 15.9999 7.99935C17.4666 7.99935 18.6666 6.79935 18.6666 5.33268Z"
      fill="#7D899C"
    />
    <defs>
      <clipPath id="clip0_1836_40755">
        <rect width="32" height="32" fill="white" />
      </clipPath>
      <clipPath id="clip1_1836_40755">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const object = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      d="M24.8327 6.59256L18.1661 3.62959C16.7871 3.0167 15.2129 3.0167 13.8339 3.62959L7.16726 6.59256C5.24125 7.44856 4 9.35854 4 11.4662V20.5342C4 22.6419 5.24125 24.5519 7.16726 25.4079L13.8339 28.3709C15.2129 28.9838 16.7871 28.9838 18.1661 28.3709L24.8327 25.4079C26.7588 24.5519 28 22.6419 28 20.5342V11.4662C28 9.35854 26.7588 7.44856 24.8327 6.59256Z"
      fill="#7D899C"
    />
    <path
      d="M24.8327 6.59256L18.1661 3.62959C16.7871 3.0167 15.2129 3.0167 13.8339 3.62959L7.16726 6.59256C6.29246 6.98136 5.55892 7.5876 5.0188 8.33103L16 13.3336L26.9812 8.33103C26.4411 7.58759 25.7075 6.98136 24.8327 6.59256Z"
      fill="#7D899C"
    />
    <path
      d="M16 9.66602C16.5523 9.66602 17 10.1137 17 10.666L17 28.7351C16.3394 28.8612 15.6606 28.8612 15 28.7351V10.666C15 10.1137 15.4477 9.66602 16 9.66602Z"
      fill="#7D899C"
    />
  </svg>
);

export const animation = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.4635 8.88284C17.6371 9.03905 17.9185 9.03905 18.092 8.88284L19.8698 7.28284C20.0434 7.12663 20.0434 6.87337 19.8698 6.71716L18.092 5.11716C17.9185 4.96095 17.6371 4.96095 17.4635 5.11716C17.2899 5.27337 17.2899 5.52663 17.4635 5.68284L18.4826 6.6H12.4444C12.199 6.6 12 6.77909 12 7C12 7.22091 12.199 7.4 12.4444 7.4H18.4826L17.4635 8.31716C17.2899 8.47337 17.2899 8.72663 17.4635 8.88284Z"
      fill="#7D899C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.1172 17.4635C22.9609 17.6371 22.9609 17.9185 23.1172 18.092L24.7172 19.8698C24.8734 20.0434 25.1266 20.0434 25.2828 19.8698L26.8828 18.092C27.0391 17.9185 27.0391 17.6371 26.8828 17.4635C26.7266 17.2899 26.4734 17.2899 26.3172 17.4635L25.4 18.4826L25.4 12.4444C25.4 12.199 25.2209 12 25 12C24.7791 12 24.6 12.199 24.6 12.4444L24.6 18.4826L23.6828 17.4635C23.5266 17.2899 23.2734 17.2899 23.1172 17.4635Z"
      fill="#7D899C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.88284 14.5365C9.03905 14.3629 9.03905 14.0815 8.88284 13.908L7.28284 12.1302C7.12663 11.9566 6.87337 11.9566 6.71716 12.1302L5.11716 13.908C4.96095 14.0815 4.96095 14.3629 5.11716 14.5365C5.27337 14.7101 5.52663 14.7101 5.68284 14.5365L6.6 13.5174L6.6 19.5556C6.6 19.801 6.77909 20 7 20C7.22091 20 7.4 19.801 7.4 19.5556L7.4 13.5174L8.31716 14.5365C8.47337 14.7101 8.72663 14.7101 8.88284 14.5365Z"
      fill="#7D899C"
    />
    <path
      opacity="0.4"
      d="M21 27.4V22.6C21 21.7163 21.7163 21 22.6 21H27.4C28.2837 21 29 21.7163 29 22.6V27.4C29 28.2837 28.2837 29 27.4 29H22.6C21.7163 29 21 28.2837 21 27.4Z"
      fill="#7D899C"
    />
    <circle opacity="0.4" cx="25" cy="7" r="4" fill="#7D899C" />
    <path
      opacity="0.4"
      d="M3 9.4V4.6C3 3.71634 3.71634 3 4.6 3H9.4C10.2837 3 11 3.71634 11 4.6V9.4C11 10.2837 10.2837 11 9.4 11H4.6C3.71634 11 3 10.2837 3 9.4Z"
      fill="#7D899C"
    />
    <path
      opacity="0.4"
      d="M6.55279 21.8944C6.73705 21.5259 7.26295 21.5259 7.44721 21.8944L10.6382 28.2764C10.8044 28.6088 10.5627 29 10.191 29H3.80902C3.43733 29 3.19558 28.6088 3.3618 28.2764L6.55279 21.8944Z"
      fill="#7D899C"
    />
  </svg>
);

export const camera = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      d="M2.66675 11.9993C2.66675 9.05383 5.05456 6.66602 8.00008 6.66602H17.3334C20.2789 6.66602 22.6667 9.05383 22.6667 11.9993V19.9993C22.6667 22.9449 20.2789 25.3327 17.3334 25.3327H8.00008C5.05456 25.3327 2.66675 22.9449 2.66675 19.9993V11.9993Z"
      fill="#7D899C"
    />
    <path
      d="M22.6667 12.444L24.7213 10.2525C26.3747 8.48888 29.3334 9.6589 29.3334 12.0763V19.9228C29.3334 22.3403 26.3747 23.5103 24.7213 21.7467L22.6667 19.5551V12.444Z"
      fill="#7D899C"
    />
    <path
      d="M18.6668 13.3327C18.6668 14.8054 17.4729 15.9993 16.0002 15.9993C14.5274 15.9993 13.3335 14.8054 13.3335 13.3327C13.3335 11.8599 14.5274 10.666 16.0002 10.666C17.4729 10.666 18.6668 11.8599 18.6668 13.3327Z"
      fill="#7D899C"
    />
  </svg>
);

export const insert = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      d="M9.33333 12L22.6667 12C25.6122 12 28 14.3878 28 17.3333L28 22.6667C28 25.6122 25.6122 28 22.6667 28L9.33333 28C6.38782 28 4 25.6122 4 22.6667L4 17.3333C4 14.3878 6.38781 12 9.33333 12Z"
      fill="#7D899C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.2929 15.2929C10.9024 15.6834 10.9024 16.3166 11.2929 16.7071L15.2929 20.7071C15.6834 21.0976 16.3166 21.0976 16.7071 20.7071L20.7071 16.7071C21.0976 16.3166 21.0976 15.6834 20.7071 15.2929C20.3166 14.9024 19.6834 14.9024 19.2929 15.2929L17 17.5858L17 4C17 3.44771 16.5523 3 16 3C15.4477 3 15 3.44772 15 4L15 17.5858L12.7071 15.2929C12.3166 14.9024 11.6834 14.9024 11.2929 15.2929Z"
      fill="#7D899C"
    />
  </svg>
);

export const FileIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      opacity="0.4"
      d="M2 4.00065L2 12.0007C2 13.4734 3.19391 14.6673 4.66667 14.6673H8.66667L14 9.33398V4.00065C14 2.52789 12.8061 1.33398 11.3333 1.33398L4.66667 1.33398C3.19391 1.33398 2 2.52789 2 4.00065Z"
      fill="white"
    />
    <path
      d="M8.66675 12.0007L8.66675 14.6673L14.0001 9.33398L11.3334 9.33398C9.86066 9.33398 8.66675 10.5279 8.66675 12.0007Z"
      fill="white"
    />
  </svg>
);

export const NotificationIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 21C13.385 21 14.5633 20.1652 15 19H9C9.43668 20.1652 10.615 21 12 21Z"
      fill="#7D899C"
    />
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.6896 3.75403C13.274 3.29116 12.671 3 12 3C10.7463 3 9.73005 4.01629 9.73005 5.26995V5.37366C7.58766 6.10719 6.0016 7.85063 5.76046 9.97519L5.31328 13.9153C5.23274 14.6249 4.93344 15.3016 4.44779 15.8721C3.35076 17.1609 4.39443 19 6.22281 19H17.7772C19.6056 19 20.6492 17.1609 19.5522 15.8721C19.0666 15.3016 18.7673 14.6249 18.6867 13.9153L18.2395 9.97519C18.2333 9.92024 18.2262 9.86556 18.2181 9.81113C17.8341 9.93379 17.4248 10 17 10C14.7909 10 13 8.20914 13 6C13 5.16744 13.2544 4.3943 13.6896 3.75403Z"
      fill="#7D899C"
    />
    <circle cx="17" cy="6" r="3" fill="#E91B16" />
  </svg>
);

export const SeperatorDashedIcon = (
  <svg
    width="16"
    height="1"
    viewBox="0 0 16 1"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line y1="0.5" x2="16" y2="0.5" stroke="#394455" strokeDasharray="2 2" />
  </svg>
);

export const SeperatorIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.66675 4.66699L9.33341 8.00033L6.66675 11.3337"
      stroke="#5C6674"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SearchIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_205_42361)">
      <path
        d="M2.5 8.33333C2.5 9.09938 2.65088 9.85792 2.94404 10.5657C3.23719 11.2734 3.66687 11.9164 4.20854 12.4581C4.75022 12.9998 5.39328 13.4295 6.10101 13.7226C6.80875 14.0158 7.56729 14.1667 8.33333 14.1667C9.09938 14.1667 9.85792 14.0158 10.5657 13.7226C11.2734 13.4295 11.9164 12.9998 12.4581 12.4581C12.9998 11.9164 13.4295 11.2734 13.7226 10.5657C14.0158 9.85792 14.1667 9.09938 14.1667 8.33333C14.1667 7.56729 14.0158 6.80875 13.7226 6.10101C13.4295 5.39328 12.9998 4.75022 12.4581 4.20854C11.9164 3.66687 11.2734 3.23719 10.5657 2.94404C9.85792 2.65088 9.09938 2.5 8.33333 2.5C7.56729 2.5 6.80875 2.65088 6.10101 2.94404C5.39328 3.23719 4.75022 3.66687 4.20854 4.20854C3.66687 4.75022 3.23719 5.39328 2.94404 6.10101C2.65088 6.80875 2.5 7.56729 2.5 8.33333Z"
        stroke="#7D899C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 17.5L12.5 12.5"
        stroke="#7D899C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_205_42361">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const crossIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Huge-icon/interface/outline/remove">
      <path
        id="Vector"
        d="M13.6569 2.34382L2.3432 13.6575M13.6569 13.6575L2.3432 2.34375"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
);

export const EditIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.0378 2.7201C19.0731 1.75945 17.5097 1.76004 16.5457 2.72142L9.0903 10.1583C8.49401 10.753 8.14344 11.5492 8.10796 12.3891L8.00182 14.9018C7.9535 16.046 8.87117 16.9998 10.0203 16.9999L12.4924 17C13.4 17 14.2692 16.6349 14.9029 15.9874L22.2984 8.40804C23.2425 7.44344 23.2326 5.90152 22.2761 4.94907L20.0378 2.7201ZM17.4985 3.67018C17.9366 3.23319 18.6473 3.23293 19.0858 3.66958L21.3241 5.89856C21.7588 6.33149 21.7634 7.03236 21.3342 7.47082L19.8489 8.98837L16.0046 5.16008L17.4985 3.67018ZM15.0526 6.10956L10.043 11.1071C9.68526 11.4639 9.47492 11.9416 9.45363 12.4456L9.3475 14.9583C9.33139 15.3397 9.63728 15.6576 10.0203 15.6576L12.4924 15.6577C13.037 15.6578 13.5585 15.4387 13.9388 15.0502L18.9084 9.94931L15.0526 6.10956Z"
      fill="#7D899C"
    ></path>
    <path
      d="M21 13V17C21 19.7614 18.7614 22 16 22H8C5.23858 22 3 19.7614 3 17V9C3 6.23858 5.23858 4 8 4H12"
      stroke="#7D899C"
      stroke-width="1.5"
      stroke-linecap="round"
    ></path>
  </svg>
);

export const ThreeDIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
    <path
      fill="#7d899c"
      d="M290.8 48.6l78.4 29.7L288 109.5 206.8 78.3l78.4-29.7c1.8-.7 3.8-.7 5.7 0zM136 92.5l0 112.2c-1.3 .4-2.6 .8-3.9 1.3l-96 36.4C14.4 250.6 0 271.5 0 294.7L0 413.9c0 22.2 13.1 42.3 33.5 51.3l96 42.2c14.4 6.3 30.7 6.3 45.1 0L288 457.5l113.5 49.9c14.4 6.3 30.7 6.3 45.1 0l96-42.2c20.3-8.9 33.5-29.1 33.5-51.3l0-119.1c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-1.3-.5-2.6-.9-3.9-1.3l0-112.2c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-12.8-4.8-26.9-4.8-39.7 0l-96 36.4C150.4 48.4 136 69.3 136 92.5zM392 210.6l-82.4 31.2 0-89.2L392 121l0 89.6zM154.8 250.9l78.4 29.7L152 311.7 70.8 280.6l78.4-29.7c1.8-.7 3.8-.7 5.7 0zm18.8 204.4l0-100.5L256 323.2l0 95.9-82.4 36.2zM421.2 250.9c1.8-.7 3.8-.7 5.7 0l78.4 29.7L424 311.7l-81.2-31.1 78.4-29.7zM523.2 421.2l-77.6 34.1 0-100.5L528 323.2l0 90.7c0 3.2-1.9 6-4.8 7.3z"
    />
  </svg>
);

export const ResetIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path
      fill="#ffffff"
      d="M125.7 160l50.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L48 224c-17.7 0-32-14.3-32-32L16 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 51.2L97.6 97.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0L125.7 160z"
    />
  </svg>
);

export const FolderIconLarge = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.3334 22.6667V13.3333C29.3334 10.3878 26.9456 8 24.0001 8H20.4445C19.2906 8 18.1677 7.62572 17.2445 6.93333L14.7556 5.06667C13.8325 4.37428 12.7096 4 11.5556 4H8.00008C5.05456 4 2.66675 6.38781 2.66675 9.33333V22.6667C2.66675 25.6122 5.05456 28 8.00008 28H24.0001C26.9456 28 29.3334 25.6122 29.3334 22.6667Z"
      fill="#7D899C"
    />
  </svg>
);

export const debug = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="512"
    height="512"
    x="0"
    y="0"
    viewBox="0 0 512 512"
    className=""
  >
    <g>
      <path
        d="M454.352 398.431 331 190.879V87.42c17.459-6.192 30-22.865 30-42.42 0-24.813-20.187-45-45-45H196c-24.813 0-45 20.187-45 45 0 19.555 12.541 36.228 30 42.42v103.459L57.659 398.413c-14.085 23.476-14.442 51.715-.953 75.539C70.196 497.776 94.594 512 121.972 512h268.055c27.378 0 51.776-14.224 65.266-38.048 13.486-23.818 13.134-52.049-.941-75.521zM196 30h120c8.271 0 15 6.729 15 15s-6.729 15-15 15H196c-8.271 0-15-6.729-15-15s6.729-15 15-15zm12.895 172.664A15.001 15.001 0 0 0 211 195V90h90v30h-15c-8.284 0-15 6.716-15 15s6.716 15 15 15h15v30h-15c-8.284 0-15 6.716-15 15s6.716 15 15 15h21.466l65.8 110.716C362.112 326.413 347.079 332 331 332c-34.968 0-64.739-25.95-65.036-26.213l-.002-.001C264.139 304.162 227.422 272 181 272c-4.587 0-9.215.321-13.872.94l41.767-70.276zm220.292 256.507C421.094 473.466 406.454 482 390.027 482H121.972c-16.427 0-31.066-8.534-39.16-22.829-8.093-14.295-7.88-31.238.604-45.377l61.501-103.482C157.353 304.799 169.477 302 181 302c34.968 0 64.74 25.951 65.006 26.186C247.551 329.566 284.39 362 331 362c22.25 0 42.237-7.287 57.631-15.43l39.953 67.224.032.054c8.451 14.085 8.665 31.028.571 45.323z"
        fill="#7d899c"
        opacity="1"
        data-original="#000000"
        className=""
      ></path>
      <circle
        cx="165.88"
        cy="377"
        r="15"
        fill="#7d899c"
        opacity="1"
        data-original="#000000"
        className=""
      ></circle>
      <circle
        cx="345.88"
        cy="407"
        r="15"
        fill="#7d899c"
        opacity="1"
        data-original="#000000"
        className=""
      ></circle>
      <circle
        cx="255.88"
        cy="437"
        r="15"
        fill="#7d899c"
        opacity="1"
        data-original="#000000"
        className=""
      ></circle>
    </g>
  </svg>
);
export const SparklesIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_159_39841)">
      <path
        d="M16 18C16.5304 18 17.0391 18.2107 17.4142 18.5858C17.7893 18.9609 18 19.4696 18 20C18 19.4696 18.2107 18.9609 18.5858 18.5858C18.9609 18.2107 19.4696 18 20 18C19.4696 18 18.9609 17.7893 18.5858 17.4142C18.2107 17.0391 18 16.5304 18 16C18 16.5304 17.7893 17.0391 17.4142 17.4142C17.0391 17.7893 16.5304 18 16 18ZM16 6C16.5304 6 17.0391 6.21071 17.4142 6.58579C17.7893 6.96086 18 7.46957 18 8C18 7.46957 18.2107 6.96086 18.5858 6.58579C18.9609 6.21071 19.4696 6 20 6C19.4696 6 18.9609 5.78929 18.5858 5.41421C18.2107 5.03914 18 4.53043 18 4C18 4.53043 17.7893 5.03914 17.4142 5.41421C17.0391 5.78929 16.5304 6 16 6ZM9 18C9 16.4087 9.63214 14.8826 10.7574 13.7574C11.8826 12.6321 13.4087 12 15 12C13.4087 12 11.8826 11.3679 10.7574 10.2426C9.63214 9.11742 9 7.5913 9 6C9 7.5913 8.36786 9.11742 7.24264 10.2426C6.11742 11.3679 4.5913 12 3 12C4.5913 12 6.11742 12.6321 7.24264 13.7574C8.36786 14.8826 9 16.4087 9 18Z"
        stroke="#7D899C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_159_39841">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const HelpIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle opacity="0.4" cx="12" cy="12" r="10" fill="#7D899C" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 7.75C11.3096 7.75 10.75 8.30964 10.75 9C10.75 9.41421 10.4142 9.75 10 9.75C9.58579 9.75 9.25 9.41421 9.25 9C9.25 7.48122 10.4812 6.25 12 6.25C13.5188 6.25 14.75 7.48122 14.75 9C14.75 9.54634 14.5899 10.0576 14.3138 10.4866C14.1409 10.7554 13.9387 11.0119 13.7523 11.2436C13.7182 11.286 13.6847 11.3275 13.6518 11.3683C13.4971 11.5597 13.3551 11.7354 13.2239 11.9158C12.9003 12.3605 12.75 12.6947 12.75 13V13.5C12.75 13.9142 12.4142 14.25 12 14.25C11.5858 14.25 11.25 13.9142 11.25 13.5V13C11.25 12.2007 11.6424 11.5398 12.011 11.0333C12.1667 10.8192 12.3373 10.6081 12.4925 10.4162C12.5236 10.3777 12.554 10.3401 12.5836 10.3033C12.7688 10.0731 12.9265 9.87065 13.0524 9.67495C13.1774 9.48068 13.25 9.24996 13.25 9C13.25 8.30964 12.6904 7.75 12 7.75Z"
      fill="#7D899C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 15.25C12.4142 15.25 12.75 15.5858 12.75 16V17C12.75 17.4142 12.4142 17.75 12 17.75C11.5858 17.75 11.25 17.4142 11.25 17V16C11.25 15.5858 11.5858 15.25 12 15.25Z"
      fill="#7D899C"
    />
  </svg>
);

export const Diamond = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
    <path d="M64 112c-8.8 0-16 7.2-16 16V384c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H64zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM176 320H400c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm-72-72c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H120c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H120c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H200c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H200c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H280c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H280c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H360c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H360c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H440c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H440c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16z" />
  </svg>
);
